(function() {

  var PVC_STD  = [6.80, 3.80, 3.25, 2.70, 2.45, 2.00, 1.75, 1.55];
  var PVC_OVER = [8.80, 5.30, 4.35, 3.60, 3.30, 2.75, 2.45, 2.20];
  var PVC_QTY_LABELS = ["50","100","150","200","250","300","400","500+"];
  var PVC_QTY_MIN    = [50, 100, 150, 200, 250, 300, 400, 500];
  var PVC_OVER_LABELS = ["50","100","150","200","250","300","400","500+"];
  var PVC_OVER_MIN    = [50, 100, 150, 200, 250, 300, 400, 500];
  var PVC_MOLD_2D = 55;
  var PVC_MOLD_3D = 65;

  var EMB_PRICES = [5.70, 4.45, 3.30, 2.70, 2.50, 2.30, 2.05];
  var EMB_QTY_LABELS = ["25","50","100","200","300","400","500+"];
  var EMB_QTY_MIN    = [25, 50, 100, 200, 300, 400, 500];
  var EMB_DIGITIZING = 25;

  var pvcSize = "std", pvcMold = "2D", pvcQty = 100;
  var embQty = 50;

  function fmt(n)  { return "$" + n.toFixed(2); }
  function fmtI(n) { return "$" + Math.round(n).toLocaleString(); }
  function fmtSave(n) { return "$" + Math.round(n).toLocaleString(); }

  function clampPVC(v) { return Math.max(50,  Math.min(99999, parseInt(v) || 50)); }
  function clampEMB(v) { return Math.max(25,  Math.min(99999, parseInt(v) || 25)); }

  function getPVCTier(qty, mins) {
    mins = mins || PVC_QTY_MIN;
    for (var i = mins.length - 1; i >= 0; i--) {
      if (qty >= mins[i]) return i;
    }
    return 0;
  }
  function getEMBTier(qty) {
    for (var i = EMB_QTY_MIN.length - 1; i >= 0; i--) {
      if (qty >= EMB_QTY_MIN[i]) return i;
    }
    return 0;
  }

  function buildProgressBar(ti, labels, mins, prices, qty, prefix) {
    var total = labels.length;
    var html = '<div class="pl-progress-wrap">';
    html += '<div class="pl-progress-label">QUANTITY TIER</div>';
    html += '<div class="pl-progress-track">';
    for (var i = 0; i < total; i++) {
      var isActive = i === ti;
      var isPast = i < ti;
      var isLast = i === total - 1;
      var cls = "pl-progress-step" + (isActive ? " pl-prog-active" : "") + (isPast ? " pl-prog-past" : "");
      html += '<div class="' + cls + '" onclick="' + prefix + 'JumpTier(' + i + ')">';
      html += '<div class="pl-prog-dot"></div>';
      html += '<div class="pl-prog-qty">' + labels[i] + (isLast ? "+" : "") + '</div>';
      html += '<div class="pl-prog-price">' + fmt(prices[i]) + '</div>';
      html += '</div>';
      if (i < total - 1) html += '<div class="pl-progress-line' + (i < ti ? ' pl-prog-line-done' : '') + '"></div>';
    }
    html += '</div></div>';
    return html;
  }

  function buildSavingsCallout(ti, qty, price, prices, mins, labels) {
    if (ti === 0) {
      if (prices.length > 1) {
        var nextPrice = prices[1];
        var nextMin = mins[1];
        var nextLabel = labels[1];
        var savingsAtNext = (price - nextPrice) * nextMin;
        return '<div class="pl-savings-box pl-savings-nudge">' +
          '<span class="pl-savings-icon">&#9113;</span>' +
          '<span class="pl-savings-text">Step up to <strong>' + nextMin + ' patches</strong> and drop to <strong>' + fmt(nextPrice) + ' each</strong> &mdash; saving <strong>' + fmtSave(savingsAtNext) + '</strong> on your order</span>' +
          '</div>';
      }
      return '';
    }
    var prevPrice = prices[ti - 1];
    var prevLabel = labels[ti - 1];
    var savedVsPrev = (prevPrice - price) * qty;
    var savedPct = Math.round((prevPrice - price) / prevPrice * 100);
    return '<div class="pl-savings-box pl-savings-win">' +
      '<span class="pl-savings-icon">&#9113;</span>' +
      '<span class="pl-savings-text">Down from <strong>' + fmt(prevPrice) + '</strong> at the ' + prevLabel + '-piece tier &mdash; <strong>' + savedPct + '% less per patch</strong>, saving <strong>' + fmtSave(savedVsPrev) + '</strong> at this quantity</span>' +
      '</div>';
  }

  function plRenderPVC() {
    var input = document.getElementById("pl-pvc-qty-input");
    if (!input) return;
    pvcQty = clampPVC(input.value);
    input.value = pvcQty;

    var isOver = pvcSize === "over";
    var prices    = isOver ? PVC_OVER       : PVC_STD;
    var qtyLabels = isOver ? PVC_OVER_LABELS : PVC_QTY_LABELS;
    var qtyMins   = isOver ? PVC_OVER_MIN    : PVC_QTY_MIN;
    var ti     = getPVCTier(pvcQty, qtyMins);
    var price  = prices[ti];
    var isMax  = ti === qtyMins.length - 1;
    var subtotal   = price * pvcQty;
    var sizeLabel  = isOver ? "4.5\"-5\" OVERSIZED" : "UP TO 4\"";

    // Qty tier label
    var ql = document.getElementById("pl-pvc-qty-label");
    if (ql) ql.innerHTML = "TIER: <span>" + (isMax ? "500+ PIECES" : qtyLabels[ti] + "\u2013" + (qtyMins[ti+1]-1) + " PIECES") + "</span>";

    // Progress bar
    var progEl = document.getElementById("pl-pvc-progress");
    if (progEl) progEl.innerHTML = buildProgressBar(ti, qtyLabels, qtyMins, prices, pvcQty, "plPVC");

    // Savings callout
    var savingsEl = document.getElementById("pl-pvc-savings");
    if (savingsEl) savingsEl.innerHTML = buildSavingsCallout(ti, pvcQty, price, prices, qtyMins, qtyLabels);

    // Summary box
    var sumEl = document.getElementById("pl-pvc-summary");
    if (sumEl) {
      sumEl.innerHTML =
        "<div class='pl-sum-title'>ESTIMATE \u2014 PVC PATCH \u00b7 " + sizeLabel + " \u00b7 " + pvcQty + " PCS</div>" +
        "<div class='pl-sum-row'><span class='pl-sum-name'>PRICE PER PATCH <span class='pl-sum-sub'>Shipping quoted separately</span></span><span class='pl-sum-val pl-sum-hero'>" + fmt(price) + "</span></div>" +
        "<div class='pl-sum-row'><span class='pl-sum-name'>\u00d7 " + pvcQty + " PATCHES</span><span class='pl-sum-val pl-sum-muted'>" + fmtI(subtotal) + "</span></div>" +
        "<div class='pl-sum-row pl-sum-total'><span class='pl-sum-name'>PATCH SUBTOTAL</span><span class='pl-sum-val pl-sum-green'>" + fmtI(subtotal) + "</span></div>" +
        "<div class='pl-sum-note'>&#9113; No mold fee \u2014 included in patch price. Shipping quoted separately per order. Velcro, 3D, glow, and other add-ons quoted separately. Final price confirmed before production.</div>";
    }

    // Tier table
    var tbody = "";
    qtyLabels.forEach(function(label, i) {
      var p = prices[i];
      var isLast = i === qtyLabels.length - 1;
      var badge = i > 0 ? ' <span class="pl-tbl-save">-' + Math.round((prices[0]-p)/prices[0]*100) + '%</span>' : '<span class="pl-tbl-base">BASE</span>';
      tbody += "<tr class='" + (i === ti ? "pl-row-hl" : "") + "'>" +
        "<td>" + label + (isLast ? "+" : "") + " pcs</td>" +
        "<td>" + fmt(p) + " ea" + badge + "</td>" +
        "<td>" + fmtI(p * qtyMins[i]) + (isLast ? "+" : "") + "</td>" +
        "</tr>";
    });
    var tb = document.getElementById("pl-pvc-tbody");
    if (tb) tb.innerHTML = tbody;
  }


  function plRenderEmb() {
    var input = document.getElementById("pl-emb-qty-input");
    if (!input) return;
    embQty = clampEMB(input.value);
    input.value = embQty;

    var ti = getEMBTier(embQty);
    var price = EMB_PRICES[ti];
    var basePrice = EMB_PRICES[0];
    var subtotal = price * embQty;
    var total = subtotal;
    var isMax = ti === EMB_QTY_MIN.length - 1;

    var ql = document.getElementById("pl-emb-qty-label");
    if (ql) ql.innerHTML = "TIER: <span>" + (isMax ? "500+ PIECES" : EMB_QTY_LABELS[ti] + "–" + (EMB_QTY_MIN[ti+1]-1) + " PIECES") + "</span>";

    // Progress bar
    var progEl = document.getElementById("pl-emb-progress");
    if (progEl) progEl.innerHTML = buildProgressBar(ti, EMB_QTY_LABELS, EMB_QTY_MIN, EMB_PRICES, embQty, "plEMB");

    // Savings callout
    var savingsEl = document.getElementById("pl-emb-savings");
    if (savingsEl) {
      savingsEl.innerHTML = buildSavingsCallout(ti, embQty, price, EMB_PRICES, EMB_QTY_MIN, EMB_QTY_LABELS);
    }

    var sumEl = document.getElementById("pl-emb-summary");
    if (sumEl) {
      sumEl.innerHTML =
        "<div class='pl-sum-title'>ESTIMATE — EMBROIDERED PATCH · ALL SIZES UP TO 5\" · " + embQty + " PCS</div>" +
        "<div class='pl-sum-row'><span class='pl-sum-name'>PRICE PER PATCH <span class='pl-sum-sub'>All sizes up to 5\" · shipping quoted separately</span></span><span class='pl-sum-val pl-sum-hero'>" + fmt(price) + "</span></div>" +
        "<div class='pl-sum-row'><span class='pl-sum-name'>&#215; " + embQty + " PATCHES</span><span class='pl-sum-val pl-sum-muted'>" + fmtI(subtotal) + "</span></div>" +
        
        "<div class='pl-sum-row pl-sum-total'><span class='pl-sum-name'>PATCH SUBTOTAL</span><span class='pl-sum-val pl-sum-green'>" + fmtI(total) + "</span></div>" +
        "<div class='pl-sum-note'>&#9113; No digitizing fee — included in patch price. Shipping quoted separately per order. One price covers all sizes up to 5\" — no size upcharges. Final price confirmed before production.</div>";
    }

    // Tier table
    var tbody = "";
    EMB_QTY_LABELS.forEach(function(label, i) {
      var p = EMB_PRICES[i];
      var isLast = i === EMB_QTY_LABELS.length - 1;
      var savings = i > 0 ? ' <span class="pl-tbl-save">-' + Math.round((EMB_PRICES[0]-p)/EMB_PRICES[0]*100) + '%</span>' : '<span class="pl-tbl-base">BASE</span>';
      tbody += "<tr class='" + (i === ti ? "pl-row-hl" : "") + "'>" +
        "<td>" + label + (isLast ? "+" : "") + " pcs</td>" +
        "<td>" + fmt(p) + " ea" + savings + "</td>" +
        "<td>" + fmtI(p * EMB_QTY_MIN[i]) + (isLast ? "+" : "") + "</td>" +
        "</tr>";
    });
    var tb = document.getElementById("pl-emb-tbody");
    if (tb) tb.innerHTML = tbody;
  }

  // Jump to tier by clicking progress step
  window.plPVCJumpTier = function(i) {
    var mins = pvcSize === 'over' ? PVC_OVER_MIN : PVC_QTY_MIN;
    pvcQty = mins[i];
    var input = document.getElementById("pl-pvc-qty-input");
    if (input) input.value = pvcQty;
    plRenderPVC();
  };
  window.plEMBJumpTier = function(i) {
    embQty = EMB_QTY_MIN[i];
    var input = document.getElementById("pl-emb-qty-input");
    if (input) input.value = embQty;
    plRenderEmb();
  };

  window.plSwitchTab = function(tab) {
    ["pvc","emb"].forEach(function(t) {
      var btn   = document.getElementById("pl-tab-" + t);
      var panel = document.getElementById("pl-panel-" + t);
      if (btn)   btn.classList[t === tab   ? "add" : "remove"]("pl-tab-on");
      if (panel) panel.classList[t === tab ? "add" : "remove"]("pl-panel-on");
    });
  };

  window.plSetPVCSize = function(size, el) {
    pvcSize = size;
    document.querySelectorAll("#pl-pvc-sizes .pl-size-btn").forEach(function(b) { b.classList.remove("pl-size-on"); });
    el.classList.add("pl-size-on");
    plRenderPVC();
  };

  window.plSetPVCMold = function(mold, el) {
    pvcMold = mold;
    document.querySelectorAll("#pl-pvc-mold .pl-tog").forEach(function(b) { b.classList.remove("pl-tog-on"); });
    el.classList.add("pl-tog-on");
    plRenderPVC();
  };

  window.plAdjPVCQty = function(d) {
    pvcQty = clampPVC(pvcQty + d);
    var input = document.getElementById("pl-pvc-qty-input");
    if (input) input.value = pvcQty;
    plRenderPVC();
  };
  window.plOnPVCQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 50) { pvcQty = Math.min(99999, n); plRenderPVC(); }
  };

  window.plAdjEmbQty = function(d) {
    embQty = clampEMB(embQty + d);
    var input = document.getElementById("pl-emb-qty-input");
    if (input) input.value = embQty;
    plRenderEmb();
  };
  window.plOnEmbQtyInput = function(v) {
    var n = parseInt(v);
    if (!isNaN(n) && n >= 25) { embQty = Math.min(99999, n); plRenderEmb(); }
  };

  function initForm() {
    var form = document.getElementById("pvc-contact-form");
    if (!form) return;
    form.addEventListener("submit", function(e) {
      e.preventDefault();
      var btn = document.getElementById("pvc-submit-btn");
      var ok  = document.getElementById("pvc-success");
      var err = document.getElementById("pvc-error");
      btn.disabled = true;
      btn.textContent = "SENDING...";
      ok.style.display = "none";
      err.style.display = "none";
      fetch("https://api.web3forms.com/submit", { method: "POST", body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function(d) {
          if (d.success) { ok.style.display = "block"; form.reset(); }
          else { err.style.display = "block"; }
          btn.textContent = "SEND MY REQUEST \u2192";
          btn.disabled = false;
        })
        .catch(function() {
          err.style.display = "block";
          btn.textContent = "SEND MY REQUEST \u2192";
          btn.disabled = false;
        });
    });
  }

  function init() {
    if (!document.getElementById("pl-pvc-summary")) return;
    plRenderPVC();
    plRenderEmb();
    initForm();
  }

  function tryInit() {
    if (document.getElementById("pl-pvc-summary")) {
      init();
    } else {
      setTimeout(tryInit, 50);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInit);
  } else {
    tryInit();
  }
  // Hard fallback at 500ms
  setTimeout(function() {
    if (document.getElementById("pl-pvc-summary")) {
      if (!document.getElementById("pl-pvc-summary").innerHTML) plRenderPVC();
      if (!document.getElementById("pl-emb-summary").innerHTML) plRenderEmb();
    }
  }, 500);

})();